import * as React from "react";
import { Keys } from "~/common/enums";
import { AutosizeTextArea } from "./AutoSizeTextArea";
import { TextArea } from "./TextArea";

const newLinesRegex = /\n/gi;

/**
 * This component don't allow enter new lines but show current value in multiple lines if
 * there is no enough space to show it in single line
 */
export class MultilineInput extends TextArea {
    keyDownHandler = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
        // don't allow type new lines
        if (event.key === Keys.Enter && !event.ctrlKey) {
            event.preventDefault();
        }
    };

    onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        // for case when user pastes text with new lines
        if (newLinesRegex.test(e.target.value)) {
            e.target.value = e.target.value.replace(newLinesRegex, " ");
        }

        super.onChange(e);
    };

    renderTextArea(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
        return <AutosizeTextArea {...props} inputRef={this.inputRef} onKeyDown={this.keyDownHandler} />;
    }
}
